// THE ASSENT SENTENCE'S TWO LINKS, FOUND INSIDE IT (WEB-PARITY-2B, AC-3), moved out of `routes/assent.tsx` so the
// assent page and "Create your account" (ACC-3a, A8) build the same sentence the same way.

import type { ReactNode } from "react";
import type { LegalDocRef } from "@contract";

/** The two phrases the app makes links, declared from the sentence (`AssentCopy.termsPhrase`, `.privacyPhrase`). */
export const TERMS_PHRASE = "Terms of Service";
export const PRIVACY_PHRASE = "Privacy Policy";

/**
 * THE CHECKBOX SENTENCE WITH ITS TWO LINKS, BUILT BY RANGE LOOKUP, NOT BY CONCATENATION (AssentCopy.swift:181-192). The
 * sentence is the source and each link is found inside it, so they cannot disagree; a phrase that is ever absent is simply
 * not linked and the words still read whole.
 */
export function sentenceWithLinks(sentence: string, links: readonly { phrase: string; doc: LegalDocRef }[]): ReactNode[] {
  const found = links
    .map((l) => ({ ...l, at: sentence.indexOf(l.phrase) }))
    .filter((l) => l.at >= 0)
    .sort((a, b) => a.at - b.at);
  const out: ReactNode[] = [];
  let from = 0;
  for (const l of found) {
    if (l.at < from) continue;
    out.push(sentence.slice(from, l.at));
    // No version, no ISO date on the page (WEB-PARITY-1B, AC-1): they stay on the element.
    out.push(
      <a key={l.phrase} href={l.doc.url} target="_blank" rel="noreferrer" data-version={l.doc.version} data-effective={l.doc.effectiveDate}>
        {l.phrase}
      </a>,
    );
    from = l.at + l.phrase.length;
  }
  out.push(sentence.slice(from));
  return out;
}
